export default __webpack_public_path__ + "en.57f8acdc.png";